import styled from '@emotion/styled'
import { IconButton, Typography } from '@mui/material'
import { FC } from 'react'
import { ArrowLeft } from '@emotion-icons/heroicons-outline/ArrowLeft'
import { Colors, Shapes } from 'src/components/theme'
import { FlexRow } from 'src/components/flex-containers'
import { Close } from '@emotion-icons/material/Close'
import { LightTooltip } from 'src/components/tooltip/light-tooltip'

const Container = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${Colors.neutral100};
  background-color: ${Colors.bgWhite};
  border: solid 1px ${Colors.neutral200};
  border-radius: ${Shapes.borderRadius}px;
  width: fit-content;
`

const BackWrapper = styled.div`
  color: ${Colors.blueDark};
  display: flex;
  gap: 4px;
`
const CloseButton = styled(IconButton)`
  background-color: ${Colors.bgWhite};
  border-radius: ${Shapes.borderRadius}px;
  width: 24px;
  height: 24px;
  padding: 0;
  :hover {
    background-color: ${Colors.neutral100};
  }
`

type SidebarCloseButtonProps = {
  onClose: () => void
}

export const SidebarCloseButton: FC<SidebarCloseButtonProps> = ({ onClose }) => (
  <LightTooltip title="Close" placement="right">
    <CloseButton onClick={onClose}>
      <Close size={16} color={Colors.neutral600} />
    </CloseButton>
  </LightTooltip>
)

type SidebarResultReturnHeaderProps = {
  padding?: string | number
  backText?: string
  resultText?: string
  onClickBack?: () => void
  onClose?: () => void
}

export const SidebarResultReturnHeader: FC<SidebarResultReturnHeaderProps> = ({
  padding = 16,
  backText = 'Back',
  resultText = '',
  onClickBack,
  onClose,
}) => {
  return (
    <FlexRow align="center" justify="space-between">
      <Container style={{ padding }} onClick={onClickBack}>
        <BackWrapper>
          <ArrowLeft size={16} />
          <Typography variant="textmdm">{backText}</Typography>
        </BackWrapper>
        <Typography variant="textmdm" color={Colors.neutral500}>
          {resultText}
        </Typography>
      </Container>
      {onClose && <SidebarCloseButton onClose={onClose} />}
    </FlexRow>
  )
}
